import { Instant, LocalDate, LocalTime, LocalDateTime, DateTimeFormatter, ZoneId, ZoneOffset } from '@js-joda/core';
import '@js-joda/timezone';
import { Locale } from '@js-joda/locale_en-us';
export function instantToLocalDateTime(x) {
    return x ? x.atZone(ZoneId.of(Intl.DateTimeFormat().resolvedOptions().timeZone)).toLocalDateTime() : null;
}
export function localDateTimeToInstant(x) {
    return x ? x.toInstant(ZoneOffset.UTC) : null;
}
export function localDateTimeToInstantZoned(x) {
    return x ? x.atZone(ZoneId.of(Intl.DateTimeFormat().resolvedOptions().timeZone)).toInstant() : null;
}
const ISO_UTC_NO_MILLIS = DateTimeFormatter.ofPattern("yyyy-MM-dd'T'HH:mm:ss'Z'");
const now = () => Instant.now().atZone(ZoneOffset.UTC).format(ISO_UTC_NO_MILLIS); // TODO: why is this a string
export { Instant, LocalDate, LocalTime, LocalDateTime, DateTimeFormatter, ZoneId, Locale, now };
